import { WrenchCogOutlineIcon } from './WrenchCogOutlineIcon';

/**
 * author: Michael Irigoyen
 * id D13707EF-6219-4BCC-93EF-2B11BC627EDE
 * name wrench-cog-outline
 * version: 7.0.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/wrench-cog-outline.svg
 * tags
 * - Settings 
 * - Hardware / Tools 
 */
export const WrenchSettingsOutlineIcon = WrenchCogOutlineIcon;
export default WrenchSettingsOutlineIcon